import React from 'react';

interface BrandProps {
  className?: string;
}

export const Brand = ({ className }: BrandProps) => {
  let pathLink = '';
  if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'nl') {
    pathLink = '/nl';
  } else if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-BE') {
    pathLink = '/fr-be';
  } else if (document.getElementsByTagName('html')[0].getAttribute('lang') === 'fr-ca') {
    pathLink = '/fr-ca';
  } else {
    pathLink = '/';
  }
  return (
    <div className={className}>
      <a href={pathLink} className='header-logo-primary'>
        <img
          src='/ui/css/img/logo-alfalaval.svg'
          alt='Alfa Laval'
          height='100px'
          width='100px'
        ></img>
      </a>
    </div>
  );
};
